import { Search } from '@/DTOS/RequestFile/Search';
import request from '../../utils/request';

const RequestFileService = {
  search: (search: Search) => {
    return request('/requestFile/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      id: any;
      company?: any;
      companyId?: any;
      workPlaceId?: any;
      workPlace?: any;
      contract?: any;
      contractId?: any;
      agentId?: any;
      agent?: any;
      statusId?: any;
      status?: any;
      number?: any;
      assignedTechnician?: any;
      assignedTechnicianId?: any;
      interventionDate?: any;
      interventionStart?: any;
      interventionEnd?: any;
      startingLatitude?: any;
      startingLongitude?: any;
      arrivalingLatitude?: any;
      arrivalingLongitude?: any;
      locationInfo?: any;
      remarks?: any;
      vehicle?: any;
      postBy?: any;
      elapsedTime?: any;
      traveledKm?: any;
      isUrgent?: any;
      requestFileSystemTypes: any[];
      telegramMessageId?: any;
      isActive?: any;
    }
  ) => {
    return request('/requestFile/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          number: formData.number,
          company: formData.company,
          companyId: formData.companyId,
          workPlace: formData.workPlace,
          workPlaceId: formData.workPlaceId,
          contract: formData.contract,
          contractId: formData.contractId,
          agent: formData.agent,
          agentId: formData.agentId,
          assignedTechnician: formData.assignedTechnician,
          assignedTechnicianId: formData.assignedTechnicianId,
          interventionDate: formData.interventionDate,
          locationInfo: formData.locationInfo,
          remarks: formData.remarks,
          isUrgent: formData.isUrgent,
          vehicle: formData.vehicle,
          postBy: formData.postBy,
          statusId: formData.statusId,
          status: formData.status,
          startingLatitude: formData.startingLatitude,
          startingLongitude: formData.startingLongitude,
          arrivalingLatitude: formData.arrivalingLatitude,
          arrivalingLongitude: formData.arrivalingLongitude,
          interventionStart: formData.interventionStart,
          interventionEnd: formData.interventionEnd,
          elapsedTime: formData.elapsedTime,
          traveledKm: formData.traveledKm,
          requestFileSystemTypes: formData.requestFileSystemTypes,
          telegramMessageId: formData.telegramMessageId,
          isActive: formData.isActive ?? false,
        },
      }),
    });
  },

  getStatuses: () => {
    return request('/requestFile/searchStatuses', {
      method: 'POST',
      body: JSON.stringify({ request: {} }),
    });
  },

  searchCars: () => {
    return request('/requestFile/searchCars', {
      method: 'POST',
      body: JSON.stringify({ request: {} }),
    });
  },

  sendNotification: (
    /** @type {any} */ id: any,
    formData: {
      id: any;
      number?: any;
      company?: any;
      companyId?: any;
      workPlaceId?: any;
      workPlace?: any;
      contract?: any;
      contractId?: any;
      agentId?: any;
      agent?: any;
      statusId?: any;
      status?: any;
      assignedTechnician?: any;
      assignedTechnicianId?: any;
      interventionDate?: any;
      interventionStart?: any;
      interventionEnd?: any;
      startingLatitude?: any;
      startingLongitude?: any;
      arrivalingLatitude?: any;
      arrivalingLongitude?: any;
      locationInfo?: any;
      remarks?: any;
      vehicle?: any;
      postBy?: any;
      elapsedTime?: any;
      traveledKm?: any;
      isUrgent?: any;
      requestFileSystemTypes: any[];
      telegramMessageId?: any;
      isActive?: any;
    }
  ) => {
    return request('/telegram/send-notification', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          number: formData.number,
          company: formData.company,
          companyId: formData.companyId,
          workPlace: formData.workPlace,
          workPlaceId: formData.workPlaceId,
          contract: formData.contract,
          contractId: formData.contractId,
          agent: formData.agent,
          agentId: formData.agentId,
          assignedTechnician: formData.assignedTechnician,
          assignedTechnicianId: formData.assignedTechnicianId,
          interventionDate: formData.interventionDate,
          locationInfo: formData.locationInfo,
          remarks: formData.remarks,
          isUrgent: formData.isUrgent,
          vehicle: formData.vehicle,
          postBy: formData.postBy,
          statusId: formData.statusId,
          status: formData.status,
          startingLatitude: formData.startingLatitude,
          startingLongitude: formData.startingLongitude,
          arrivalingLatitude: formData.arrivalingLatitude,
          arrivalingLongitude: formData.arrivalingLongitude,
          interventionStart: formData.interventionStart,
          interventionEnd: formData.interventionEnd,
          elapsedTime: formData.elapsedTime,
          traveledKm: formData.traveledKm,
          requestFileSystemTypes: formData.requestFileSystemTypes,
          telegramMessageId: formData.telegramMessageId,
          isActive: formData.isActive ?? false,
        },
      }),
    });
  },

  delete: (telegramMessageId: any) => {
    return request('/requestFile/delete', {
      method: 'POST',
      body: JSON.stringify({ request: { telegramMessageId: telegramMessageId } }),
    });
  },

  deleteNotification: (telegramMessageId: number) => {
    return request(`/telegram/delete-notification/${telegramMessageId}`, {
      method: 'POST',
    });
  },
};

export default RequestFileService;
